import React from "react";
import Select from "react-select";
import "./MultiSelect.css";
import { Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';

const IncidentMultiselect = ({
  options,
  onChangeForRegion,
  errors,
  name,
  label,
  is_multi,
  mandatory,
  control,
  disabled = false,
  multiselcinci,
   ...props
}) => {
  const { t } = useTranslation();

  // Custom option component to handle "All Users" display
  const CustomOption = ({ innerProps, label, data }) => {
    if (multiselcinci && data.value === "all") {
      return (
        <div {...innerProps} style={{ padding: '8px 12px', cursor: 'pointer' }}>
          <div style={{ color: 'black' }}>All Users</div>
        </div>
      );
    }
    return <div {...innerProps} style={{ padding: '8px 12px', cursor: 'pointer', color: 'black' }}>{label}</div>;
  };

  // Custom value container to show selected value(s)  ({selectedValue.users.length})
  const CustomValueContainer = ({ children, ...props }) => {
    const selectedValue = props.getValue()[0];
    return (
      <div style={{
        padding: '5px',
        // whiteSpace: 'nowrap',
        overflow: 'auto',
        // textOverflow: 'ellipsis',
        // display: 'flex',
        paddingTop: '8px'
      }}>
        {multiselcinci && selectedValue?.value === "all" ? (
          <div style={{
            padding: '2px 8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex'
          }}>
            All Users
          </div>
        ) : (
          children
        )}
      </div>
    );
  };

  // Custom MultiValue component to display selected items horizontally
  const CustomMultiValue = ({ data, ...props }) => (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: '#17A3A0',
        borderRadius: '2px',
        marginRight: '4px',
        marginBottom: '4px',
        padding: '2px 5px',
        color: 'white',
        fontSize: '12px',
      }}
    >
      {data.label || data.value}
      <span
        style={{
          marginLeft: '5px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
        onClick={(e) => {
          e.stopPropagation();
          props.removeProps.onClick();
        }}
      >
        ×
      </span>
    </div>
  );

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#000",
    }),
    control: (base, state) => ({
      ...base,
      background: "#252b48",
      fontSize: "12px",
      borderColor: state.isFocused
        ? "#ffa100"
        : errors && errors[name]
          ? "#f4694c"
          : "#000",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#ffa100" : "#000",
      },
      ...(disabled && {
        backgroundColor: "#7c8091",
        color: "#7c8091",
        cursor: "not-allowed",
        borderColor: "#7c8091",
      }),
      // Allow the control to grow with content
      minHeight: '38px',
      height: 'auto',
    }),
    multiValue: (base) => ({
      ...base,
      display: 'none', // Hide the default multi-value
    }),
    valueContainer: (base) => ({
      ...base,
      flexWrap: 'nowrap', // Prevent wrapping to new line
      overflowX: 'auto', // Add horizontal scrolling if needed
      padding: '2px 8px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#17A3A0",
    }),
  };
  //style={{ width: multiselcinci ? '225%' : 'auto' }}
  return (
    <div id={"container_" + name} style={{ width: '100%', maxWidth: '500px' }}>
      <label style={{ color: disabled ? "#6c659d" : "white" }}>
        {t(label)} {mandatory && <span className="asterisk">*</span>}
      </label>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <Select
           {...props}
            styles={customStyles}
            placeholder={t("multiselectplaceholder")}
            classNamePrefix="react-select"
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: disabled
                ? {}
                : {
                  ...theme.colors,
                  primary25: "#17A3A0",
                  neutral50: "#fff",
                  neutral80: "#fff",
                  primary: "black",
                },
            })}
            value={value}
          onChange={onChange}
            options={options}
            isMulti={is_multi === false ? false : true}
            isDisabled={disabled}
            components={{
              Option: CustomOption,
              ValueContainer: multiselcinci ? CustomValueContainer : undefined,
              MultiValue: is_multi === false ? undefined : CustomMultiValue,
            }}
            getOptionValue={option => option.value || option.id} // Handle both structures
            getOptionLabel={option => option.label || option.user_name} // Handle both structures
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
          />
        )}
      />
      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};

export default IncidentMultiselect;